import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=3a883d27&scoped=true&"
import script from "./ArrowLink.vue?vue&type=script&lang=js&"
export * from "./ArrowLink.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=3a883d27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a883d27",
  null
  
)

export default component.exports